import { loadable } from '@shared/core/loadableFromNamedExport';

// For the guest site, where nearly every visitor is a guest who never sees it. Consumers render it
// only while one of its dialogs is open, so the chunk stays out of the guest bundle.
export const LazyUnpublishedWebsiteWarning = loadable(
  () => import(/* webpackChunkName: "shared/unpublished-website-warning" */ './UnpublishedWebsiteWarning'),
  'UnpublishedWebsiteWarning',
);
